import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { MyWalletComponent } from './my-wallet/my-wallet.component';
import { PaymentMethodsComponent } from './payment-methods/payment-methods.component';
import { TransactionsHistoryComponent } from './transactions-history/transactions-history.component';
import { MyAccountComponent } from './my-account.component';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { AuthGuard } from '../../core/authentication/auth.guard';

const routes: Routes = [
    {
        path: '',
        component: MyAccountComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                redirectTo: 'my-profile',
                pathMatch: 'full'
            },
            {
                path: 'my-profile',
                component: MyProfileComponent
            },
            {
                path: 'my-wallet',
                component: MyWalletComponent
            },
            {
                path: 'payment-methods',
                component: PaymentMethodsComponent
            },
            {
                path: 'transactions-history',
                component: TransactionsHistoryComponent
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MyAccountRoutingModule {}
